import api from './api';

class CustomerService {
  // Get all customers with pagination and filtering
  static async getCustomers(params = {}) {
    try {
      const response = await api.get('/customers', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw this.handleError(error);
    }
  }

  // Get customer by ID
  static async getCustomer(id) {
    try {
      const response = await api.get(`/customers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer:', error);
      throw this.handleError(error);
    }
  }

  // Create new customer
  static async createCustomer(customerData) {
    try {
      const response = await api.post('/customers', customerData);
      return response.data;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw this.handleError(error);
    }
  }

  // Update customer
  static async updateCustomer(id, customerData) {
    try {
      const response = await api.put(`/customers/${id}`, customerData);
      return response.data;
    } catch (error) {
      console.error('Error updating customer:', error);
      throw this.handleError(error);
    }
  }

  // Delete customer
  static async deleteCustomer(id) {
    try {
      const response = await api.delete(`/customers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting customer:', error);
      throw this.handleError(error);
    }
  }

  // Get customer statistics
  static async getCustomerStats() {
    try {
      const response = await api.get('/customers/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching customer stats:', error);
      throw this.handleError(error);
    }
  }

  // Bulk operations
  static async bulkCustomerOperations(operation, customerIds, data = {}) {
    try {
      const response = await api.post('/customers/bulk', {
        operation,
        customerIds,
        data
      });
      return response.data;
    } catch (error) {
      console.error('Error performing bulk customer operations:', error);
      throw this.handleError(error);
    }
  }

  // Export customers
  static async exportCustomers(format = 'csv') {
    try {
      const response = await api.get('/customers/export', {
        params: { format },
        responseType: format === 'csv' ? 'blob' : 'json'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting customers:', error);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        message: error.response.data?.message || 'An error occurred',
        status: error.response.status,
        data: error.response.data
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default CustomerService;
